import clsx from 'clsx';
import { forwardRef, type ReactNode } from 'react';

import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import { canReceiveDefaultTextFormat as _canReceiveDefaultTextFormat } from '../../core/utils/can-receive-default-text-format.js';
import { Text } from '../../typography/text/Text.js';
import { subtitleCSS } from './TitleBar.sty.js';

//#region Typings
/**
 * Accepted properties for the TitleBar Subtitle
 * @public
 */
export interface TitleBarSubtitleProps extends StylingProps, DataTestId {
  /** Elements to be displayed in the TitleBar Subtitle slot. */
  children: ReactNode;
}
//#endregion

/**
 * TitleBar Subtitle component
 * @public
 */
export const Subtitle = /* @__PURE__ */ forwardRef<
  HTMLDivElement,
  TitleBarSubtitleProps
>((props, forwardedRef) => {
  const {
    children,
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  }: TitleBarSubtitleProps = props;
  const childIsText = _canReceiveDefaultTextFormat(props.children);

  return (
    <div
      ref={forwardedRef}
      className={clsx(subtitleCSS, consumerClassName)}
      style={consumerStyle}
      data-testid={dataTestId}
    >
      {childIsText ? (
        <Text textStyle="base" as="p">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
});
